import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { FeatureFlags } from 'featureFlags/constants';
import { useWindowSize } from 'shared/hooks/useWindowSize';

export const useIsNewMobileMenu = () => {
  const { isMobileOrTablet } = useWindowSize();
  const isNewMobileMenuEnabled = useFeatureFlag(FeatureFlags.TEMP_WEB_ENABLE_NEW_MOBILE_MENU);

  return isMobileOrTablet && isNewMobileMenuEnabled;
};
